import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';

export function PanelContentNoWarnings() {
  return (
    <li data-module="PanelContentNoWarnings" className="WarningsPanel-item">
      <p>For information on developing severe weather, you may want to view our:</p>
      <LinkFactoryReactRouter href="/warnings/severe-weather-outlook">Severe weather outlook</LinkFactoryReactRouter>,
      <LinkFactoryReactRouter href="/warnings/thunderstorm-outlook">Thunderstorm outlook</LinkFactoryReactRouter>,
      <LinkFactoryReactRouter href="/warnings/tropical-cyclone-activity">
        Tropical cyclone activity
      </LinkFactoryReactRouter>
      ,
    </li>
  );
}
